import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {ShippingCharge} from '../../interfaces/common/shipping-charge.interface';
import {Observable} from 'rxjs';

const API_SHOP_INFO = environment.apiBaseLink + '/api/shipping-charge/';


@Injectable({
  providedIn: 'root'
})
export class ShippingChargeService {

  private shippingChargeRes: any = null;
  private shippingChargeByUserRes: any = null;

  constructor(
    private httpClient: HttpClient
  ) {
  }

  /**
   * getOrderOffer()
   * getOrderOfferWithUser()
   */




  getShippingCharge(select?: string) {
    let params = new HttpParams();
    if (select) {
      params = params.append('select', select);
    }

    return new Observable<{data: ShippingCharge; message: string; success: boolean}>(observer => {
      if (this.shippingChargeRes) {
        observer.next(this.shippingChargeRes);
        observer.complete();
      } else {
        this.httpClient.get<{
          data: ShippingCharge,
          message: string,
          success: boolean
        }>(API_SHOP_INFO + 'get', {params})
          .subscribe({
            next: res => {
              this.shippingChargeRes = res;
              observer.next(this.shippingChargeRes);
              observer.complete();
            },
            error: err => {
              console.log(err);
            }
          })
      }
    })
  }

  getShippingChargeByUser(select?: string) {
    let params = new HttpParams();
    if (select) {
      params = params.append('select', select);
    }

    return new Observable<{data: ShippingCharge; message: string; success: boolean}>(observer => {
      if (this.shippingChargeByUserRes) {
        observer.next(this.shippingChargeByUserRes);
        observer.complete();
      } else {
        this.httpClient.get<{
          data: ShippingCharge,
          message: string,
          success: boolean
        }>(API_SHOP_INFO + 'get-by-user', {params})
          .subscribe({
            next: res => {
              this.shippingChargeByUserRes = res;
              observer.next(this.shippingChargeByUserRes);
              observer.complete();
            },
            error: err => {
              console.log(err);
            }
          })
      }
    })
  }



}
